import React, {useEffect} from 'react';
import {Form, Formik} from "formik";
import * as Yup from "yup";
import FormNav from "./FormNavBar";
import Tab1 from "./tabs/Tab1";
import Tab2 from "./tabs/Tab2";

function ExchangeRateFormWizard({ tab, setTab, isLoading, submitData }) {
    /* Auto scroll to top on new tab */
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, [tab])

    const validationSchema = Yup.object({
        fromCurrency: Yup.string().required('Required'),
        toCurrency: Yup.string().required('Required'),
        rate: Yup.number().required('Required'),
        userGroup: Yup.string().required('Required')
    })

    return (
        <Formik
            initialValues={{
                fromCurrency: "",
                toCurrency: "",
                rate: 1.0,
                userGroup: ""
            }}
            validationSchema={validationSchema}
            onSubmit={async (values) => {
                submitData(values)
            }}
        >{({status, validateForm, values}) => (
            <Form>
                <div className="text-warning">{status}</div>
                <div className="container">
                    <div className="card card-custom card-transparent" id="user-wizard">
                        <div className="card-body p-0">
                            {/* <!--begin: Wizard--> */}
                            <div className="wizard wizard-4" id="kt_wizard" data-wizard-state="step-first"
                                 data-wizard-clickable="true">
                                <FormNav tab={tab} setTab={setTab}/>
                                {/* <!--begin: Wizard Body--> */}
                                <div className="card card-custom card-shadowless rounded-top-0">
                                    <div className="card-body p-0">
                                        <div className="row justify-content-center py-8 px-8 py-lg-15 px-lg-10">
                                            <div className="col-xl-12 col-xxl-8">
                                                <Tab1
                                                    tab={tab}
                                                    onValidate={() => {
                                                        validateForm().then((errors) => {
                                                            if (errors.fromCurrency || errors.toCurrency || errors.rate || errors.userGroup) return;
                                                            setTab(2)
                                                        })
                                                    }}
                                                />
                                                <Tab2
                                                    tab={tab}
                                                    setTab={setTab}
                                                    isSubmitting={isLoading}
                                                    exchangeRateData={values}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!--end: Wizard Bpdy--> */}
                            </div>
                            {/* <!--end: Wizard--> */}
                        </div>
                    </div>
                </div>
            </Form>
        )}
        </Formik>
    );
}

export default ExchangeRateFormWizard;